import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  Button,
  Card,
  Form,
  message,
  Modal,
  Popconfirm,
  Radio,
  Select,
} from "antd";
// import { APIConstants } from "../../../../../../Common/APIConstants";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  ClockCircleFilled,
  CloseCircleOutlined,
  CloseCircleFilled,
  CloseOutlined,
} from "@ant-design/icons";
// import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import CustomThemeDrawer from "../../../../../../Elements/CustomThemeDrawer";
// import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";

const ScreenConfiguration = () => {
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  const [open, setOpen] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [refetch, setRefetch] = useState(false);
  const [users, setUsers] = useState([]);
  const [screens, setScreens] = useState([]);
  const [header, setHeader] = useState([]);
  const [roles, setRoles] = useState([]);
  const [updatedAccess, setUpdateAccess] = useState([]);
  const [form] = Form.useForm();
  const [roleActions, setRoleActions] = useState([]);
  const loggedIn = useSelector((state) => state.user);
  const [edit,setEdit]=useState(false)
  //console.log(loggedIn);
  //   //console.log(color);
  const { isdarkMode } = mode;
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    // form1.resetFields()
    setOpen(false);
  };
  const getRoles = () => {
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_ROLES}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setRoles(res);
      }
    });
  };
  useEffect(() => {
    getRoles();
  }, [refetch]);
  const getUsers = () => {
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_ROLE_ACTIONS}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setUsers(res);
      }
    });
  };

  const extractTrueRoles = (row) => {
    const { menuDetailID, screenName, ...roles } = row;

    // get only roleIds where value is true
    const trueRoleIds = Object.keys(roles)
      .filter((key) => roles[key] === true)
      .join(","); // join into "1,2,3"

    return {
      menuDetailID,
      roleIds: trueRoleIds, // string like "2,3"
    };
  };
  const insertRolesActions = () => {
    //console.log(roleActions);

    const body = {
      roleActionDetails: roleActions,
    };
    ////console.log(body);
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_INSERT_ROLE_ACTIONS}`;
    ////console.log(url);

    if(roleActions&&roleActions.length){
    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    }).then((res) => {
      ////console.log(res);
      setRefetch(!refetch);
      setEdit(false)
      setRoleActions([])
      // if (res) {
      //   setUsers(res);
      //   setUpdateAccess();
      // }
    });
    }
  };
  useEffect(() => {
    getUsers();
  }, [refetch]);

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const CheckboxRenderer = (props) => {
  const handleChange = (e) => {
    const updatedValue = e.target.checked;

    // find roleId & menuDetailID
    const roleId = roles.find((i) => i.roleName === props.colDef.field).roleId;
    const menuDetailID = screens.find(
      (i) => i.screenName === props.data.screenName
    ).menuDetailID;

    const data = {
      flag: updatedValue,
      roleStatus: updatedValue,
      menuDetailsID: menuDetailID,
      roleID: roleId,
      userID: loggedIn.roleId,
    };

    // ✅ Always keep object, even if unchecked
    setRoleActions((prev) => {
      const filtered = prev.filter(
        (item) =>
          !(item.menuDetailsID === menuDetailID && item.roleID === roleId)
      );
      return [...filtered, data]; // keep checked/unchecked
    });

    //  update screens row
    setScreens((prevScreens) =>
      prevScreens.map((row) =>
        row.screenName === props.data.screenName
          ? { ...row, [props.colDef.field]: updatedValue }
          : row
      )
    );
  };

  //  derive checked state directly from roleActions
  const roleId = roles.find((i) => i.roleName === props.colDef.field)?.roleId;
  const menuDetailID = screens.find(
    (i) => i.screenName === props.data.screenName
  )?.menuDetailID;

  const matched = roleActions.find(
    (item) => item.menuDetailsID === menuDetailID && item.roleID === roleId
  );

  const isChecked = matched ? matched.flag : props.value;

  return <input type="checkbox" checked={!!isChecked} onChange={handleChange} />;
};


  const createRoleCols = (roles) => {
    // const baseCols = [
    //   { headerName: "Module", field: "module", flex: 2,minWidth:120 },
    // ];

    // const roleCols = roles.map((role) => ({
    //   headerName: role.roleName,
    //   field: role.roleName, // field name will be roleName
    //   width: 120,
    //   cellRenderer: CheckboxRenderer,
    //   editable: true,
    // }));

    // return [...baseCols, ...roleCols];
    const menuCols = [
      {
        headerName: "Screen Name",
        field: "screenName",
        flex: 2,
        minWidth: 180,
      },
    ];

    //console.log(roles);
    // add role columns dynamically
    roles.forEach((role) => {
      menuCols.push({
        headerName: role.roleName,
        field: role.roleName,
        cellRenderer: CheckboxRenderer,
        width: 120,
        // editable: true,
      });
    });
    return menuCols;
  };
  useEffect(() => {
    setHeader(createRoleCols(roles));
  }, [roles]);

  const deleteRoles = (formValues) => {
    //console.log(formValues);

    const body = {
      groupID: formValues.groupID,
    };

    const url = `${APIConstants.ELECTRICAL_DELETE_DASHBOARD_METER_DETAILS}?AutoID=${formValues.autoID}`;

    //console.log(url);
    //console.log(body);

    // makeRequest({
    //   type: APIConstants.DELETE,
    //   url: url,
    //   body: body,
    // }).then((res) => {
    //   //console.log(res);
    //   // onClose2();
    //   setRefetch(!refetch);
    //   handleNotification(res.message, "error");
    // });
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_GET_SCREENS}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        //console.log(users);
        //console.log(roles);
        const rowData = res.map((screen) => {
          const row = {
            screenName: screen.screenName,
            menuDetailID: screen.menuDetailID,
          };
          roles.forEach((role) => {
            row[role.roleName] = false;
          });
          return row;
        });
        //console.log(rowData);
        const roleMap = Object.fromEntries(
          roles.map((r) => [r.roleId, r.roleName])
        );

        // Update screens with roleActions
        const updatedScreens = rowData.map((screen) => {
          const updated = { ...screen };

          users.forEach((action) => {
            if (action.menuDetailID === screen.menuDetailID) {
              const roleKey = roleMap[action.roleId];
              if (roleKey) {
                updated[roleKey] = true;
              }
            }
          });

          return updated;
        });

        console.log(updatedScreens); 

        setScreens(updatedScreens); 
      }
    });
  }, [refetch,roles,users]);

  console.log(header);
  console.log(screens);
  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Role Actions
        </h2>

        <div className="flex gap-4 min-h-screen ">
          {/*  Roles Configuration */}
          <Card
            // title={
            //   <span className={isdarkMode ? "text-white" : "text-black"}>
            //     Role Actions
            //   </span>
            // }
            // footer={
            //   <Button type="primary" onClick={() => showDrawer()}>
            //     Add +
            //   </Button>
            // }
            className={`w-full rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade,
                height: "160vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={screens}
                columnDefs={header}
                domLayout="normal"
                rowHeight={50}
              />
            </div>
            <div className="flex justify-end items-end m-4">
              <Button type="primary" onClick={() => insertRolesActions()}>
                Save Changes
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ScreenConfiguration;
